<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <template v-if=readonly>
                            <h4 class="card-title">View Seller</h4>
                            <h6 class="card-subtitle">View an existing seller</h6>
                        </template>
                        <template v-else>
                            <h4 class="card-title">Edit Seller</h4>
                            <h6 class="card-subtitle">Edit an existing seller</h6>
                        </template>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body card-blue">
                            <h6 class="card-title">Business Info</h6>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="biz_name">Legal
                                    Name</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('biz_name')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="Business Name"
                                           id="biz_name"
                                           name="biz_name"
                                           placeholder="Business Name"
                                           type="text"
                                           v-model="partner.biz_name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('biz_name')">{{
                                        errors.first('biz_name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="biz_name">Description</label>
                                <div class="col-sm-7">
                                    <textarea :readonly="readonly"
                                              class="form-control"
                                              id="description"
                                              name="description"
                                              placeholder="Description"
                                              rows="7"
                                              v-model="partner.description">
                                    </textarea>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="biz_phone">Phone</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('biz_phone')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="Phone"
                                           id="biz_phone"
                                           name="biz_phone"
                                           placeholder="Phone"
                                           type="text"
                                           v-model="partner.biz_phone"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('biz_phone')">{{
                                        errors.first('biz_phone') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="biz_email">Email</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('biz_email')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="Phone"
                                           id="biz_email"
                                           name="biz_email"
                                           placeholder="Email"
                                           type="text"
                                           v-model="partner.biz_email"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('biz_email')">{{
                                        errors.first('biz_email') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="biz_web">Web</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('biz_web')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="Web"
                                           id="biz_web"
                                           name="biz_web"
                                           placeholder="Web"
                                           type="text"
                                           v-model="partner.biz_web"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('biz_web')">{{
                                        errors.first('biz_web') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="biz_web">DID</label>
                                <div class="col-sm-7">
                                    <input :class="{'is-invalid': submitted && errors.has('did')}" :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="DID"
                                           id="did"
                                           name="did"
                                           placeholder="DID"
                                           type="text"
                                           v-model="partner.did"
                                           v-validate="">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('did')">{{
                                        errors.first('did') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="audit">Audit</label>
                                <div class="col-sm-7">
                                    <input :class="{'is-invalid': submitted && errors.has('audit')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="Audit"
                                           id="audit"
                                           name="audit"
                                           placeholder="Audit"
                                           type="text"
                                           v-model="partner.audit"
                                           v-validate="'url'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('audit')">{{
                                        errors.first('audit') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="line1">Address</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('line1')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="Address Line 1"
                                           id="line1"
                                           name="line1"
                                           placeholder="Address Line 1"
                                           type="text"
                                           v-model="partner.line1"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('line1')">{{
                                        errors.first('line1') }}
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <input :class="{'is-invalid': submitted && errors.has('line2')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="Address Line 2"
                                           id="line2"
                                           name="line2"
                                           placeholder="Address Line 2"
                                           type="text"
                                           v-model="partner.line2">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('line2')">{{
                                        errors.first('line2') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="city"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('city')}" :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="City"
                                           id="city"
                                           name="city"
                                           placeholder="City"
                                           type="text"
                                           v-model="partner.city"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('city')">{{
                                        errors.first('city') }}
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <input :class="{'is-invalid': submitted && errors.has('state')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="State"
                                           id="state"
                                           name="state"
                                           placeholder="State or Province"
                                           type="text"
                                           v-model="partner.state"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('state')">{{
                                        errors.first('state') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="postal_code"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('postal_code')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="Postal Code"
                                           id="postal_code"
                                           name="postal_code"
                                           placeholder="Postal Code"
                                           type="text"
                                           v-model="partner.postal_code"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('postal_code')">{{
                                        errors.first('postal_code') }}
                                    </div>
                                </div>
                                <div class="col-sm-4" v-if="!readonly">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('country')}"
                                                 :options="countries"
                                                 class="form-control multiselect-sm"
                                                 data-vv-as="Country"
                                                 id="country"
                                                 label="name"
                                                 name="country"
                                                 placeholder="Country"
                                                 track-by="name"
                                                 v-model="partner.country"
                                                 v-validate="'required'">
                                    </multiselect>

                                    <div class="invalid-feedback" v-if="submitted && errors.has('country')">{{
                                        errors.first('country') }}
                                    </div>
                                </div>
                                <div class="col-sm-4" v-else>
                                    <input :class="{'is-invalid': submitted && errors.has('state')}"
                                           :readonly="readonly"
                                           class="form-control"
                                           data-vv-as="State"
                                           name="state"
                                           placeholder="State or Province"
                                           type="text"
                                           v-model="partner.country.name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('state')">{{
                                        errors.first('state') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <div class="d-md-flex align-items-center">
                                    <div>
                                        <h4 class="card-title">Attachment</h4>
                                        <h5 v-if="readonly" class="card-subtitle">Attached files of this seller</h5>
                                        <h5 v-else class="card-subtitle">Upload files of the seller</h5>
                                    </div>
                                    <div class="ml-auto d-flex no-block align-items-center" v-if="!readonly">
                                        <div class="dl">
                                            <div class="button-group"><a
                                                    class="btn waves-effect waves-light btn-info text-white"
                                                    data-target="#attachmentModal"
                                                    data-toggle="modal"><i
                                                    class="fas fa-plus"></i> Add Attachment
                                            </a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body card-blue" v-if="partner.attachments && partner.attachments.length>0">
                                <div class="table-responsive p-t-25">
                                    <table class="table no-wrap v-middle">
                                        <thead>
                                        <tr class="bg-light">
                                            <th><h6>File Name</h6></th>
                                            <th><h6>Title</h6></th>
                                            <th><h6>Description</h6></th>
                                            <th v-if="!readonly"><h6>Action</h6></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-bind:key="index" v-for="(a, index) in partner.attachments">
                                            <td>
                                                <a @click="downloadFile(a.filepath, a.filename)"
                                                   href="javascript:void(0)">{{a.filename}}</a>
                                            </td>
                                            <td>{{a.title}}</td>
                                            <td>{{a.desc}}</td>
                                            <td v-if="!readonly">
                                                <a @click="deleteFile(a.id, a.filepath)"
                                                   class="text-danger"
                                                   href="javasript:void(0);">
                                                    <b>Remove</b>
                                                </a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card-body card-blue" v-else>
                                <h4 class="card-title text-muted text-center">No records found</h4></div>
                        </div>

                        <div class="card-footer">
                            <div class="m-b-5 w-50 text-right float-right">
                                <div class="button-group">
                                    <template v-if="!readonly">
                                        <button class="btn waves-effect waves-light btn-success" type="submit">Save
                                        </button>
                                        <button @click="reset()" class="btn waves-effect waves-light btn-secondary"
                                                type="button">Reset
                                        </button>
                                    </template>
                                    <!--                                    <button v-if="readonly" @click="readonly = false" class="btn btn-outline-secondary"-->
                                    <!--                                            type="button">Edit-->
                                    <!--                                    </button>-->
                                    <router-link :to="{ name: 'sellers' }" class="btn btn-outline-secondary"
                                                 type="button">Back
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="attachmentModal" role="dialog"
             tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form>
                        <div class="modal-header">
                            <h4 class="modal-title" id="attachmentModalLabel">Upload Attachments</h4>
                            <button aria-hidden="true" class="close"
                                    data-dismiss="modal" type="button">×
                            </button>
                        </div>
                        <div class="modal-body card-blue">
                            <div class="card-body">
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <input
                                                class="form-control"
                                                name="file_title"
                                                placeholder="Title"
                                                style="height: 42px;"
                                                type="text"
                                                v-model="fileTitle">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <textarea
                                                class="form-control"
                                                data-vv-as="description"
                                                id="description"
                                                name="description"
                                                placeholder="File Description"
                                                rows=3
                                                v-model="fileDesc">
                                        </textarea>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="input-group col-md-8">
                                        <div class="custom-file">
                                            <input @change="handleFileChange"
                                                   class="custom-file-input"
                                                   id="inputGroupFile01"
                                                   ref="attachment"
                                                   type="file">
                                            <label class="custom-file-label" for="inputGroupFile01"
                                                   style="cursor: pointer">{{filename}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="uploadFile()" class="btn btn-success" data-dismiss="modal"
                                    type="button">Submit
                            </button>
                            <button class="btn waves-effect waves-light btn-danger"
                                    data-dismiss="modal"
                                    type="button">Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from "vuex";
    import countries from "../../../../../assets/js/countries";
    import uuid from "uuid/v4";
    import axios from "axios";
    import _ from "lodash";

    export default {
        name: "EditPartner",
        components: {Multiselect},
        props: ["sellerid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                isLoading: false,
                submitted: false,
                countries: countries,
                file: null,
                fileTitle: null,
                fileDesc: null,
                new_attachments: [],
                partner: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    biz_name: '',
                    biz_phone: '',
                    biz_web: '',
                    biz_email: '',
                    did: '',
                    audit: '',
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: {},
                    attachments: [],
                    new_attachments: []
                },
                partner_bkp: null,
                readonly: true,
                filename: "Upload Attachment",
            };
        },
        mounted() {
            if (this.$route.name === 'editseller') {
                this.readonly = false;
            }
            this.getMember();
        },
        methods: {
            async getMember() {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http.get("/express/" + this.currentOrg.express_id + "/purchases/sellers/" + this.sellerid);
                    $(".preloader").fadeOut();
                    this.partner = reply.data;

                    this.partner_bkp = reply.data;
                    this.partner_bkp.country = {
                        name: this.partner_bkp.country
                    }
                } catch (e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                }
            },
            async save() {
                try {
                    this.partner.new_attachments = this.new_attachments;
                    console.log(this.partner);
                    await this.$http.post("/express/" + this.currentOrg.express_id + "/purchases/sellers/" + this.sellerid, this.partner);
                    this.$toastr('success', 'Seller Added', 'Success');
                    this.resetAttachment();
                    this.$router.push({name: "sellers"});
                } catch (e) {
                }
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        if (valid) {
                            this.save();
                        }
                    });
            },
            reset() {
                this.partner = {...this.partner_bkp};
            },
            handleFileChange(e) {
                this.file = this.$refs.attachment.files[0];
                this.filename = this.file.name;
            },
            async uploadFile() {

                try {
                    let filename = this.file.name;
                    let contenttype = this.file.type.split('/')[1];

                    // get signed url and upload file to s3;

                    let reply = await this.$http.get(`express/${this.currentOrg.express_id}/receipts/signedUrl`, {
                        params:
                            {
                                type: 'write',
                                filename: filename,
                                contenttype: contenttype
                            }
                    });

                    this.new_attachments.push({
                        id: uuid(),
                        filename: this.filename,
                        title: this.fileTitle,
                        url: reply.data.url,
                        desc: this.fileDesc,
                        filepath: reply.data.key,
                        contenttype: contenttype
                    });

                    this.partner.attachments = _.union(this.partner.attachments, this.new_attachments);
                    await axios.put(reply.data.url, this.file);
                    this.resetAttachment();
                } catch (e) {

                }
            },
            async deleteFile(id, filepath) {
                try {

                    $(".preloader").fadeIn();
                    await this.$http.delete(`/express/${this.currentOrg.express_id}/partner/attachments`, {
                        data: {
                            filepath: filepath,
                            docid: id,
                            partner_id: this.partner.partner_id
                        }
                    });
                    _.remove(this.partner.attachments, function (a) {
                        return a.id == id;
                    });
                    this.partner.attachments = JSON.parse(JSON.stringify(this.partner.attachments));
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Attachment deleted successfully', 'Success');
                } catch (e) {
                    $(".preloader").fadeOut();
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            resetAttachment() {
                this.file = null;
                this.fileTitle = null;
                this.fileDesc = null;
                this.filename = "Upload Attachment";
            },
            async downloadFile(filepath, filename) {
                let reply = await this.$http.get(`express/${this.currentOrg.express_id}/partner/signedUrl`, {
                    params: {
                        type: 'read',
                        filepath: filepath,
                        filename: filename
                    }
                });
                let link = document.createElement('a');
                link.href = reply.data.url;
                link.download = filename;
                link.click();
            }
        }
    }
</script>

<style scoped>

</style>
